import { RouterProvider } from 'react-router-dom';

import { QueryProvider } from './providers/QueryProvider';
import { SessionProvider } from './providers/SessionProvider';
import { router } from './router/routes';
import { ToastProvider } from '@/shared/ui/organisms/Toast';

export function App() {
  return (
    <QueryProvider>
      <ToastProvider>
        <SessionProvider>
          <RouterProvider router={router} />
        </SessionProvider>
      </ToastProvider>
    </QueryProvider>
  );
}
